import { render, staticRenderFns } from "./classtypes.vue?vue&type=template&id=28b2c9b5&scoped=true&"
import script from "./classtypes.vue?vue&type=script&lang=js&"
export * from "./classtypes.vue?vue&type=script&lang=js&"
import style0 from "./classtypes.vue?vue&type=style&index=0&id=28b2c9b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2c9b5",
  null
  
)

export default component.exports